import {
  requestPostFile,
  requestGet, 
} from "../config/Api";

export const uploadJudicialAccountsZip = (data) => {
  return requestPostFile('legal/file/judicial/account/upload', data);
};

export const getJudicialAccounts = (params) => {
  return requestGet("legal/file/judicial/account", { params });
};